import React, { useEffect } from "react";
import styled from "styled-components";
import NumberInput from "common/NumberInput";
import SelectInput from "common/SelectInput";
import useChoiceOrValue from "common/hooks/useChoiceOrValue";

const doesNothing = () => {};

const InputWrapper = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: flex-end;
  justify-content: flex-start;
  min-height: 34px !important;
  & > * {
    flex: 100;
    min-width: 15ch;
  }
`;

const ChoiceOrValueInput = ({
  name,
  defaultSelectValue = "spec",
  defaultValue = "any",
  options = [],
  onChange = doesNothing,
  ValueInput = NumberInput,
  ...settings
}) => {
  const [value, select, setSelect, setValue] = useChoiceOrValue(
    options,
    defaultValue,
    defaultSelectValue
  );

  useEffect(() => {
    onChange(value);
  }, [value]);

  return (
    <InputWrapper>
      <input type="hidden" value={value} name={name} />
      <SelectInput
        options={options}
        defaultValue={select}
        onChange={(event) => setSelect(event.target.value)}
      />
      {select !== "spec" ? null : (
        <ValueInput
          label=""
          className="margin-b-0 margin-l-10"
          defaultValue={value}
          onChange={(event) => setValue(event.target.value)}
          {...settings}
        />
      )}
    </InputWrapper>
  );
};
export default ChoiceOrValueInput;
